export const ESIGN_SIGNING_ACTIONS_OWNER = 'ESign Signing Actions';
export const ESIGN_SIGNING_ACTIONS = {
    /** Initiator: opens the document so signature field guides can be placed. */
    OPEN_ESIGN_FIELD_SETUP: 'Open ESign Field Setup',
    /** Signatory: opens the document so the signatory can place and submit their signature. */
    OPEN_ESIGN_SIGNING: 'Open ESign Signing',
};
